import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

const BaseURL = process.env.REACT_APP_API_URL;
const token = Cookies.get("authToken");

const DataBase = Cookies.get("Database");
const ProjectIDs = 1;

export const BankName = createAsyncThunk("Bank/BankName ", async (data) => {
  try {
    const response = await axios.post(
      `${BaseURL}/Bank/BankName `,
      {
        FirmIDs: data.Firm,
        DataBase: DataBase,
        ProjectIDs: ProjectIDs,
        AcYearIDs: data.Year,
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "Network Error");
  }
});

export const BankAcRecPayMonth = createAsyncThunk(
  "Bank/BankAcRecPayMonth ",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Bank/BankAcRecPayMonth `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BankIDs: data.BankIDs ? data.BankIDs : "",
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BankPositionStatus1 = createAsyncThunk(
  "Bank/BankPositionStatus",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Bank/BankPositionStatus `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BankIDs: data.BankIDs ? data.BankIDs : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BankRecPayMonth = createAsyncThunk(
  "Bank/BankRecPayMonth",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Bank/BankRecPayMonth`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BankIDs: data.BankIDs ? data.BankIDs : "",
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BankSummaryGroup = createAsyncThunk(
  "Bank/BankSummaryGroup",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Bank/BankSummaryGroup`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BankIDs: data.BankIDs ? data.BankIDs : "",
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BankRecPayBalMonthDay = createAsyncThunk(
  "Bank/BankRecPayBalMonthDay",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Bank/BankRecPayBalMonthDay`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BankIDs: data.BankIDs ? data.BankIDs : "",
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BankRecPayBalGroupList = createAsyncThunk(
  "Bank/BankRecPayBalGroupList",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Bank/BankRecPayBalGroupList`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          BankIDs: data.BankIDs ? data.BankIDs : "",
          GroupMstIDs: data.selectedIds ? data.selectedIds : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BankFasTdsName = createAsyncThunk(
  "Bank/BankFasTdsName ",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Bank/BankFasTdsName `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BankFasTdsPay = createAsyncThunk(
  "Bank/BankFasTdsPay ",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Bank/BankFasTdsPay `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          TDSAc: data.TDSAc ? data.TDSAc : "",
          NaturePayment: data.NaturePayment ? data.NaturePayment : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BankFasGstSalePur = createAsyncThunk(
  "Bank/BankFasGstSalePur ",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Bank/BankFasGstSalePur `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BankFasTdsRec = createAsyncThunk(
  "Bank/BankFasTdsRec  ",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Bank/BankFasTdsRec  `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          TDSAc: data.TDSAc ? data.TDSAc : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BankFasTdsNatureName = createAsyncThunk(
  "Bank/BankFasTdsNatureName  ",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/Bank/BankFasTdsNatureName  `,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          TDSAc: data.TDSAc ? data.TDSAc : "",
          StartDate: data.startDate ? data.startDate : "",
          EndDate: data.endDate ? data.endDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const BankSlice = createSlice({
  name: "FAS",
  initialState: {
    BankNamedata: null,
    BankAcRecPayMonthdata: null,
    BankPositionStatusdata: null,
    BankRecPayMonthdata: null,
    BankSummaryGroupdata: null,
    BankRecPayBalMonthDaydtaa: null,
    BankRecPayBalGroupListdata: null,
    BankFasTdsNamedata: null,
    BankFasTdsPaydata: null,
    BankFasGstSalePurdata: null,
    BankFasTdsNatureNamedata: null,
    BankFasTdsRecdata: null,
    status: "idle",
    error: null,
  },
  reducers: {
    BankAcRecPayMonthFun: (state) => {
      state.BankAcRecPayMonthdata = "no";
    },
    BankPositionStatusFun: (state) => {
      state.BankPositionStatusdata = "no";
    },
    BankRecPayMonthFun: (state) => {
      state.BankRecPayMonthdata = "no";
    },
    BankRecPayMonthFunn: (state) => {
      state.BankAcRecPayMonthdata = "no";
    },
    BankSummaryGroupFun: (state) => {
      state.BankSummaryGroupdata = "no";
    },

    BankFasGstSalePurFun: (state) => {
      state.BankFasGstSalePurdata = "no";
    },
    BankFasTdsPayFun: (state) => {
      state.BankFasTdsPaydata = "no";
    },
    BankFasTdsRecFun: (state) => {
      state.BankFasTdsRecdata = "no";
    },
    BankFasTdsNatureNameFun: (state) => {
      state.BankFasTdsNatureNamedata = "no";
    },
    BankFasTdsNameFun: (state) => {
      state.BankFasTdsNamedata = "no";
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(BankName.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BankName.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BankNamedata = action.payload;
      })
      .addCase(BankName.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(BankAcRecPayMonth.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BankAcRecPayMonth.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BankAcRecPayMonthdata = action.payload;
      })
      .addCase(BankAcRecPayMonth.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(BankPositionStatus1.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BankPositionStatus1.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BankPositionStatusdata = action.payload;
      })
      .addCase(BankPositionStatus1.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(BankRecPayMonth.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BankRecPayMonth.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BankRecPayMonthdata = action.payload;
      })
      .addCase(BankRecPayMonth.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(BankSummaryGroup.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BankSummaryGroup.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BankSummaryGroupdata = action.payload;
      })
      .addCase(BankSummaryGroup.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(BankRecPayBalMonthDay.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BankRecPayBalMonthDay.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BankRecPayBalMonthDaydtaa = action.payload;
      })
      .addCase(BankRecPayBalMonthDay.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(BankRecPayBalGroupList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BankRecPayBalGroupList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BankRecPayBalGroupListdata = action.payload;
      })
      .addCase(BankRecPayBalGroupList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(BankFasTdsName.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BankFasTdsName.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BankFasTdsNamedata = action.payload;
      })
      .addCase(BankFasTdsName.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(BankFasTdsPay.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BankFasTdsPay.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BankFasTdsPaydata = action.payload;
      })
      .addCase(BankFasTdsPay.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(BankFasGstSalePur.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BankFasGstSalePur.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BankFasGstSalePurdata = action.payload;
      })
      .addCase(BankFasGstSalePur.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(BankFasTdsNatureName.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BankFasTdsNatureName.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BankFasTdsNatureNamedata = action.payload;
      })
      .addCase(BankFasTdsNatureName.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(BankFasTdsRec.pending, (state) => {
        state.status = "loading";
      })
      .addCase(BankFasTdsRec.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.BankFasTdsRecdata = action.payload;
      })
      .addCase(BankFasTdsRec.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const {
  BankSummaryGroupFun,
  BankRecPayMonthFun,
  BankPositionStatusFun,
  BankAcRecPayMonthFun,
  BankFasTdsNameFun,
  BankFasTdsNatureNameFun,
  BankFasTdsRecFun,
  BankFasTdsPayFun,
  BankFasGstSalePurFun,
  BankRecPayMonthFunn,
} = BankSlice.actions;

export default BankSlice.reducer;
